// extracted by mini-css-extract-plugin
module.exports = {"outer":"content_area_wrapper-module--outer--2zWpx","inner":"content_area_wrapper-module--inner--3sR66","contained":"content_area_wrapper-module--contained--2BhWn"};